import React from "react";

interface DrawerContentProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  openDrawer?: () => void;
}
const DrawerContent: React.FC<DrawerContentProps> = ({ children, className = "", openDrawer }) => {
  // Clone children and pass openDrawer prop to them
  const childrenWithProps = React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { openDrawer } as any);
    }
    return child;
  });

  return <div className={className.trim()}>{childrenWithProps}</div>;
};

export default DrawerContent;
